import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import SalesCard from "../home/common/SalesCard";

const Checkins = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Checkins">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <SalesCard user={userInfoData} clickedCard={"checkins"} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Checkins;
